import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ project, report }) =>
    present(
      repository
        .removeProjectReport(project, report)
        .then(() => ({ project, report }))
        .catch(() => Promise.reject({ project, report })),
    );
}

export type { Interactor };

export { createInteractor };
